function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.39324942,16 L9.39324942,8.70162481 L11.8429581,8.70162481 L12.2097672,5.85731849 L9.39324942,5.85731849 L9.39324942,4.04140862 C9.39324942,3.21791631 9.62192009,2.65673347 10.802788,2.65673347 L12.3089285,2.65607532 L12.3089285,0.112104938 C12.0484472,0.0774423547 11.1543866,0 10.1142165,0 C7.9426861,0 6.45599764,1.32551475 6.45599764,3.75972029 L6.45599764,5.85731849 L4,5.85731849 L4,8.70162481 L6.45599764,8.70162481 L6.45599764,16 L9.39324942,16 Z",
  id: "facebook-icon"
});

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 16",
    width: "0.6428571428571429rem",
    height: "1.142857142857143rem",
    fill: "currentColor",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.1df64368.svg";
export { ForwardRef as ReactComponent };